"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnsQueryBuilderPlugin = exports.TableColumnsQueryBuilder = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const ColumnsSelector_1 = require("../selectors/ColumnsSelector");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const StyledGrid = (0, styled_components_1.default)(core_1.Grid) `
  display: flex;
  align-items: center;
  &.display-name {
    flex-grow: 0;
    max-width: 30%;
    flex-basis: 30%;
  }
`;
const StyledTypography = (0, styled_components_1.default)(core_1.Typography) `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const TableColumnsQueryBuilder = props => {
    var _a;
    const { type, params } = props;
    const vertical = true;
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    // temporary state to clear autocomplete
    const [selectedColumnMap, setSelectedColumnMap] = (0, react_1.useState)(null);
    const [debounceSet] = (0, core_ui_1.useTimeout)();
    const columnsKey = (params.columns || [])
        .map(column => column.path)
        .join(',');
    // remove any columns from options that are already selected
    const filteredOptions = (0, react_1.useMemo)(() => {
        return queryManager.queryAliasColumnMap.filter(columMap => {
            var _a;
            return !((_a = params.columns) === null || _a === void 0 ? void 0 : _a.some(column => (column === null || column === void 0 ? void 0 : column.path) === columMap.path));
        });
        // re-evaluate when columns are updated since
        // the columns array does not change reference
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnsKey, params.columns, queryManager]);
    const update = (updateParams = {}) => {
        var _a, _b, _c, _d;
        const index = (_d = (_c = (_b = (_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.pluginConfigs) === null || _c === void 0 ? void 0 : _c.findIndex(pluginConfig => pluginConfig.type === type)) !== null && _d !== void 0 ? _d : -1;
        queryManager.updatePluginConfig(index, {
            type: exports.TableColumnsQueryBuilderPlugin.type,
            params: Object.assign(Object.assign({}, params), updateParams)
        });
    };
    (0, react_1.useEffect)(() => {
        selectedColumnMap && setSelectedColumnMap(null);
    }, [selectedColumnMap]);
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 }, (_a = params.columns) === null || _a === void 0 ? void 0 :
        _a.map((column, index) => {
            const columnMap = queryManager.queryAliasColumnMap.find(columnMap => columnMap.path === column.path);
            const displayName = columnMap
                ? (0, ColumnsSelector_1.getEntityColumnDisplay)(columnMap, vertical)
                : '';
            return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, key: `${column.path}-${index}` },
                react_1.default.createElement(core_1.Grid, { container: true, spacing: 1 },
                    react_1.default.createElement(StyledGrid, { item: true, className: 'display-name' }, columnMap && (react_1.default.createElement(StyledTypography, { variant: 'body2', title: displayName }, displayName))),
                    react_1.default.createElement(StyledGrid, { item: true }, ":"),
                    react_1.default.createElement(core_1.Grid, { item: true, style: { flex: 1 } },
                        react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', variant: 'outlined', placeholder: 'Header Text', defaultValue: column.label, onChange: event => {
                                // calling update() every change is slow
                                // use defaultValue instead and update column label
                                debounceSet(() => {
                                    column.label = event.target.value;
                                    update();
                                }, 300);
                            } })),
                    react_1.default.createElement(StyledGrid, { item: true },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(core_1.Tooltip, { title: `${column.hidden ? 'Unhide' : 'Hide'} Column` },
                                react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => {
                                        column.hidden = !column.hidden;
                                        update();
                                    } }, column.hidden ? (react_1.default.createElement(icons_1.VisibilityOff, { fontSize: 'small' })) : (react_1.default.createElement(icons_1.Visibility, { fontSize: 'small' })))),
                            react_1.default.createElement(core_1.Tooltip, { title: 'Remove Field' },
                                react_1.default.createElement(core_1.IconButton, { size: 'small', style: { marginLeft: 2 }, onClick: () => {
                                        params.columns = params.columns || [];
                                        params.columns.splice(index, 1);
                                        update();
                                    } },
                                    react_1.default.createElement(icons_1.Close, { fontSize: 'small' }))))))));
        }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(lab_1.Autocomplete, { fullWidth: true, clearOnBlur: true, clearOnEscape: true, value: selectedColumnMap, options: filteredOptions, getOptionLabel: option => (0, ColumnsSelector_1.getEntityColumnDisplay)(option, vertical), onChange: (_, columnMap) => {
                    setSelectedColumnMap(columnMap);
                    if (!(columnMap === null || columnMap === void 0 ? void 0 : columnMap.path)) {
                        return;
                    }
                    params.columns = params.columns || [];
                    params.columns.push({ path: columnMap.path });
                    update();
                }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Add Field Config' }))) }),
            react_1.default.createElement(core_1.FormHelperText, { style: { marginLeft: 4 } }, exports.TableColumnsQueryBuilderPlugin.description))));
};
exports.TableColumnsQueryBuilder = TableColumnsQueryBuilder;
exports.TableColumnsQueryBuilderPlugin = {
    name: 'Table Columns',
    type: 'TableColumns',
    description: 'Customize Table column header texts and column visibility.',
    component: exports.TableColumnsQueryBuilder
};
//# sourceMappingURL=TableColumnsQueryBuilderPlugin.js.map